var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"name":_vm.name,"type":"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }